import HttpRequest from "tools/httpRequest";
import * as BackEndConsts from "tools/constants/backEndConstants";
import { platformNotifMessages } from "tools/commonFunctions";
import { isSessionLogoutError } from "tools/authToken";
import { createQueriesLainotik } from './queriesLainotik';
import { createMutationsLainotik } from './mutationsLainotik';
import i18n from "localization/i18n";

const handleBackEndErrorMessage = (backEndResponse, expectedSuccessCode = BackEndConsts.RESPONSE_SUCCESS) => {
  // Check if the backend response is under the element "response"
  const isResponseFormat = backEndResponse.hasOwnProperty('response');

  const responsePayload = isResponseFormat ? backEndResponse.response : backEndResponse;

  const responseCodeNum = responsePayload && responsePayload.code != null ? Number(responsePayload.code) : NaN;
  const expectedCodeNum = expectedSuccessCode != null ? Number(expectedSuccessCode) : NaN;
  const codeMatches = Number.isFinite(responseCodeNum) && Number.isFinite(expectedCodeNum)
    ? responseCodeNum === expectedCodeNum
    : responsePayload.code === expectedSuccessCode;
  const messageOk = typeof responsePayload.message === "string" && responsePayload.message.trim().toUpperCase() === "OK";

  if (!codeMatches && !messageOk) {
    let backEndResponseData = BackEndConsts.BACKEND_RESPONSE_ERROR; // Constant with the string value "Error"

    const messageInfo = responsePayload.messageinfo;

    const rawLevel = String(messageInfo && messageInfo.messagelevel ? messageInfo.messagelevel : "").trim().toUpperCase();
    const notifLevel = (rawLevel === "WARNING" || rawLevel === "DANGER") ? rawLevel : "DANGER";
    const notifTitle = String(messageInfo && messageInfo.messagetitle ? messageInfo.messagetitle : "").trim()
      || String(responsePayload.error || "").trim()
      || i18n.t("common.error");
    const notifMessage = String(messageInfo && messageInfo.message ? messageInfo.message : "").trim()
      || String(responsePayload.message || "").trim();

    platformNotifMessages(
      notifLevel,
      notifTitle,
      notifMessage
    )
    if (messageInfo && String(messageInfo.messagecode || "") === BackEndConsts.DEMO_DEPLOY_MESSAGECODE) {
      return backEndResponse;
    }
    return backEndResponseData;
  } else {
    return backEndResponse;
  }
};

const handleBackEndInternalError = (error) => {
  if (error && !isSessionLogoutError(error)) {
    const resMessage =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();
    platformNotifMessages(
      "DANGER",
      i18n.t("common.commDataErrorTitle"),
      resMessage);
  }
  return BackEndConsts.BACKEND_RESPONSE_ERROR;
};

const dataServiceFunctions = {
  handleBackEndErrorMessage,
  handleBackEndInternalError
};

const httpClient = new HttpRequest();
const queriesLainotik = createQueriesLainotik(
  httpClient,
  dataServiceFunctions,
  i18n);
const mutationsLainotik = createMutationsLainotik(
  httpClient,
  dataServiceFunctions,
  i18n,
  BackEndConsts);

export const dataService = {
  queries: queriesLainotik,
  mutations: mutationsLainotik
};
